import React from 'react';
import ActionButton from '../input/ActionButton';
import { useOffline } from '../context/OfflineContext';
import './ReconnectButton.css';

// "Erneut verbinden" — neben dem App-Neustart der einzige Weg aus dem Offline-Modus. Kurze Probe:
// Erfolg -> Seiten laden frische Daten, offene Check-ins werden übertragen. Sonst bleibt die App offline.
function ReconnectButton() {
  const { reconnecting, reconnect } = useOffline();

  return (
    <span className={`reconnectButton ${reconnecting ? 'reconnecting' : ''}`}>
      <ActionButton
        icon="sync"
        label={reconnecting ? 'Verbinde …' : 'Erneut verbinden'}
        type={4}
        onClick={reconnect}
        disabled={reconnecting}
      />
    </span>
  );
}

export default ReconnectButton;
